import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Header,
    Image,
    Modal,
    Grid,
    Select,
    Card,
    Icon
} from "semantic-ui-react";
import CardImage from "../Images/culture.jpg";
import ModalImage from "../Images/card.png";
// import { withRouter } from "react-router-dom";
import { openModal } from "../../features/modals/modalActions";
import { selectedCategory } from "../../features/selections/selectActions";
import "./CategoryPage.css";
// import CardComponent from "./CardComponent";

const actions = {
    openModal,
    selectedCategory
};

const mapState = state => ({
    auth: state.firebase.auth
});

class CategoryPage extends Component {
    numbers = [
        { key: "three", value: 3, text: "Model of 3" },
        { key: "five", value: 5, text: "Model of 5" },
        { key: "ten", value: 10, text: "Model of 10" }
    ];

    // topicTitles = ["Bangla", "English", "Math"];
    topicTitles = ["Category", "Category1", "Category2"];
    dimmerValue = true;
    routeParamValue = "";
    isRouteParamValueSet = false;
    state = {
        numberOfQus: 0,
        selectedTopic: "",
        open: false,
        calledOnce: false
    };

    show = value => () => {
        this.setState({ selectedTopic: value, open: false });
    };

    componentDidUpdate = () => {
        this.redirectToCategoryTestPage();
    };

    close = () => {
        console.log("close button called");
        this.setState({ open: false });
        this.isRouteParamValueSet = false;
    };

    handleModelChange = (event, data) => {
        this.setState({
            numberOfQus: data.value
        });
        this.routeParamValue = this.state.selectedTopic + " " + data.value;
        this.isRouteParamValueSet = true;
    };

    redirectToTestPage = () => {
        if (this.isRouteParamValueSet) {
            this.props.history.push({
                pathname: "/test",
                query: { value: this.routeParamValue }
            });

            this.isRouteParamValueSet = false;
        }
    };

    redirectToCategoryTestPage = () => {
        console.log("Im here");

        if (this.state.selectedTopic !== "") {
            const { selectedCategory } = this.props;
            let category = this.state.selectedTopic + "Tests";
            selectedCategory(category);
            this.props.history.push({
                pathname: "/categoryTestPage"
            });
        }
    };

    render() {
        // const { open, dimmer } = this.state;
        const { auth } = this.props;
        const isUserLoggedIn = auth.isLoaded && !auth.isEmpty;

        // if (auth.hasOwnProperty("emailVerified")) {
        //     console.log("have found property ", auth);
        //     console.log(
        //         auth.emailVerified ? "Email Verified" : "Email not verified"
        //     );
        //     if (auth.emailVerified) {
        //         toastr.success("Thank You!", "Your email has been verified");
        //     } else {
        //         toastr.error(
        //             "Oops!",
        //             "Please, verify your email to access the content"
        //         );
        //     }
        // }
        return (
            <div>
                <div>
                    <Grid>
                        <Grid.Row style={{ justifyContent: "center" }}>
                            <Grid.Column mobile={16} tablet={8} computer={4}>
                                {/* <CardComponent /> */}
                                <Card
                                    className="box"
                                    style={{
                                        marginRight: "20px",
                                        marginTop: "20px",
                                        width: "100%"
                                    }}
                                >
                                    <Image src={CardImage} />
                                    <Card.Content>
                                        <Card.Header>
                                            {this.topicTitles[0]}
                                        </Card.Header>
                                        <Card.Description>
                                    Lorem Ipsum is simply dummy text of the
                                    printing and typesetting industry. Lorem
                                    Ipsum has been the industry's
                                </Card.Description>
                                    </Card.Content>
                                    <Card.Content extra>
                                        <Button
                                            primary
                                            onClick={
                                                isUserLoggedIn
                                                    ? this.show(
                                                          this.topicTitles[0]
                                                      )
                                                    : () => {
                                                          this.props.openModal(
                                                              "LoginModal"
                                                          );
                                                      }
                                            }
                                            animated="vertical"
                                        >
                                            <Button.Content hidden>
                                                Take
                                            </Button.Content>
                                            <Button.Content visible>
                                                <Icon name="pencil" />
                                            </Button.Content>
                                        </Button>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>

                            <Grid.Column mobile={16} tablet={8} computer={4}>
                                <Card
                                    style={{
                                        marginRight: "20px",
                                        marginTop: "20px",
                                        width: "100%"
                                    }}
                                >
                                    <Image src={CardImage} />
                                    <Card.Content>
                                        <Card.Header>
                                            {this.topicTitles[1]}
                                        </Card.Header>
                                        <Card.Description>
                                            Lorem Ipsum is simply dummy text of
                                            the printing and typesetting
                                            industry. Lorem Ipsum has been the
                                            industry's
                                        </Card.Description>
                                    </Card.Content>
                                    <Card.Content extra>
                                        <Button
                                            primary
                                            disabled
                                            onClick={
                                                isUserLoggedIn
                                                    ? this.show(
                                                          this.topicTitles[1]
                                                      )
                                                    : () => {
                                                          this.props.openModal(
                                                              "LoginModal"
                                                          );
                                                      }
                                            }
                                            animated="vertical"
                                        >
                                            <Button.Content hidden>
                                                Take
                                            </Button.Content>
                                            <Button.Content visible>
                                                <Icon name="pencil" />
                                            </Button.Content>
                                        </Button>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>

                            <Grid.Column mobile={16} tablet={8} computer={4}>
                                <Card
                                    style={{
                                        marginRight: "20px",
                                        marginTop: "20px",
                                        width: "100%"
                                    }}
                                >
                                    <Image src={CardImage} />
                                    <Card.Content>
                                        <Card.Header>
                                            {this.topicTitles[2]}
                                        </Card.Header>
                                        <Card.Description>
                                            Lorem Ipsum is simply dummy text of
                                            the printing and typesetting
                                            industry. Lorem Ipsum has been the
                                            industry's
                                        </Card.Description>
                                    </Card.Content>
                                    <Card.Content extra>
                                        <Button
                                            primary
                                            disabled
                                            onClick={
                                                isUserLoggedIn
                                                    ? this.show(
                                                          this.topicTitles[2]
                                                      )
                                                    : () => {
                                                          this.props.openModal(
                                                              "LoginModal"
                                                          );
                                                      }
                                            }
                                            animated="vertical"
                                        >
                                            <Button.Content hidden>
                                                Take
                                            </Button.Content>
                                            <Button.Content visible>
                                                <Icon name="pencil" />
                                            </Button.Content>
                                        </Button>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column width={16} />

                        <div>
                            <Modal
                                dimmer={this.dimmerValue}
                                open={this.state.open}
                                onClose={this.close}
                            >
                                <Modal.Header />
                                <Modal.Content image>
                                    <Image
                                        wrapped
                                        size="small"
                                        src={ModalImage}
                                    />
                                    <Modal.Description>
                                        <Header>
                                            {this.state.selectedTopic}
                                        </Header>
                                        <p>
                                            Lorem ipsum dolor sit amet
                                            consectetur adipisicing elit.
                                            Accusamus, nemo quae eveniet
                                        </p>
                                        <Select
                                            placeholder="Select your number"
                                            options={this.numbers}
                                            onChange={this.handleModelChange}
                                        />
                                        {!this.isRouteParamValueSet && (
                                            <p style={{ color: "red" }}>
                                                Please select first
                                            </p>
                                        )}
                                    </Modal.Description>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button color="red" onClick={this.close}>
                                        Cancel
                                    </Button>
                                    <Button
                                        positive
                                        icon="checkmark"
                                        labelPosition="right"
                                        content="Okay"
                                        onClick={this.redirectToTestPage}
                                    />
                                </Modal.Actions>
                            </Modal>
                        </div>
                    </Grid>
                </div>
            </div>
        );
    }
}

export default connect(
    mapState,
    actions
)(CategoryPage);
